module.exports = __webpack_public_path__ + "img/icon_flower.9b57abcc.png";